import xs from 'xstream';
import BASE_URL from './variables';
import {getLawsysArrayQueryParameter,getArrayQueryParameterMachineName} from "../helpers/functions";
import { failedGetApplicableInternalAlerts, failedGetInternalAlerts, getApplicableInternalAlerts, getInternalAlerts, receiveApplicableInternalAlerts, receiveInternalAlerts } from '../reducers/internalAlerts';
import {failedGetInternalAlertById, getInternalAlertById, receiveInternalAlertById } from '../reducers/internalAlertForm';

export function requestInternalAlerts(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === getInternalAlerts.type)
        .map(action => ({
            url: BASE_URL + 'api/InternalAlerts?limit='+ action.payload.limit+
            '&offset=' + action.payload.offset +
            (getLawsysArrayQueryParameter(action.payload.filterFirms) ?
            `&${getLawsysArrayQueryParameter(action.payload.filterFirms)}` : '')+
            (getArrayQueryParameterMachineName('caseTypeMachineNames', action.payload.filterCaseTypes) ?
            `&${getArrayQueryParameterMachineName('caseTypeMachineNames', action.payload.filterCaseTypes)}` : '')+
            (getArrayQueryParameterMachineName('subCaseTypeMachineNames', action.payload.filterSubCaseTypes) ?
                `&${getArrayQueryParameterMachineName('subCaseTypeMachineNames', action.payload.filterSubCaseTypes)}` : '')+
                (action.payload.filterValidFrom !== ''?`&validFrom=${action.payload.filterValidFrom}`:'') +
                (action.payload.filterValidTo !== ''?`&validTo=${action.payload.filterValidTo}`:'') +
                (action.payload.filterSearch !== ''?`&search=${action.payload.filterSearch}`:''),
            category: 'requestInternalAlerts',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestInternalAlerts')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => receiveInternalAlerts(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestInternalAlertsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestInternalAlerts')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => failedGetInternalAlerts(response));

    return {
        ACTION: httpResponse$
    };
}



export function requestInternalAlertById(sources) {
    const request$ = sources.ACTION
    .filter(action => action.type === getInternalAlertById.type)
    .map(action => ({
        url: BASE_URL + 'api/InternalAlerts/' + action.payload,
        category: 'requestInternalAlertsById',
        method: 'GET',
        type: 'application/json',
        withCredentials: true
    }));

let httpResponse$ = sources.HTTP
    .select('requestInternalAlertsById')
    .map((response) =>
        response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => receiveInternalAlertById(response));

return {
    ACTION: httpResponse$,
    HTTP: request$
};
}
export function requestInternalAlertByIdFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestInternalAlertsById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => failedGetInternalAlertById(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestApplicableInternalAlerts(sources) {
    const request$ = sources.ACTION
    .filter(action => action.type === getApplicableInternalAlerts.type)
    .map(action => ({
        url: BASE_URL + `api/Applications/${action.payload}/activeAlerts`,
        category: 'requestApplicableInternalAlerts',
        method: 'GET',
        type: 'application/json',
        withCredentials: true
    }));

let httpResponse$ = sources.HTTP
    .select('requestApplicableInternalAlerts')
    .map((response) =>
        response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => receiveApplicableInternalAlerts(response));

return {
    ACTION: httpResponse$,
    HTTP: request$
};
}
export function requestApplicableInternalAlertsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestApplicableInternalAlerts')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => failedGetApplicableInternalAlerts(response));

    return {
        ACTION: httpResponse$
    };
}

